<template>
	<div>
		<loader v-if="!activeItem"/>
		<template v-else>
			<header>
				<h1 class="alpha heavy">Edit Fact Find</h1>
			</header>
			<div>
				<div class="sections">
					<div class="section--floating section--full">
						<the-fact-find-form
							v-if="activeItem" :fact-find="activeItem" cta="Update Fact Find" method="patch"/>
					</div>
				</div>
			</div>
		</template>
	</div>
</template>
<script>
import {createNamespacedHelpers} from "vuex";
import TheFactFindForm from "./forms/TheFactFindForm.vue";

const {mapActions, mapGetters} = createNamespacedHelpers("factFinds");

export default {
	components: {
		TheFactFindForm,
	},

	computed: mapGetters([
		"activeItem",
	]),

	methods: mapActions([
		"activateModel",
	]),

	created() {
		this.activateModel(this.$route.params.factFind);
	},
};
</script>
